import { useSelector } from "react-redux";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { selectAllUniqueWebsites } from "../../../../sub-modules/opportunities/store/selectors";

import Quota from "./Quota";

const QuotaContainer = () => {
    const allUniqueWebsites = useSelector(selectAllUniqueWebsites);
    const quotaLimit = salesSettingsHelper.getQuotaLimit();

    if (allUniqueWebsites.length === 0) {
        return null;
    }

    return (
        <Quota
            allUniqueWebsites={allUniqueWebsites}
            quotaLimit={quotaLimit}
        />
    );
};

export default QuotaContainer;
